import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-4310cd96"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  key: 0,
  class: "spinner-overlay"
};
var _hoisted_2 = {
  class: "is-flex is-justify-content-center mt-6"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_divider = _resolveComponent("el-divider");

  var _component_el_button = _resolveComponent("el-button");

  var _component_el_radio = _resolveComponent("el-radio");

  var _component_el_radio_group = _resolveComponent("el-radio-group");

  var _component_el_form_item = _resolveComponent("el-form-item");

  var _component_el_input = _resolveComponent("el-input");

  var _component_el_form = _resolveComponent("el-form");

  var _component_el_row = _resolveComponent("el-row");

  var _component_el_dialog = _resolveComponent("el-dialog");

  return _openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _ctx.modalVisible,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) {
      return _ctx.modalVisible = $event;
    }),
    width: "500px",
    "custom-class": "send-email-modal"
  }, {
    title: _withCtx(function () {
      return [_createElementVNode("h2", null, _toDisplayString(_ctx.$t("Email")), 1), _createVNode(_component_el_divider, {
        class: "mb-0"
      })];
    }),
    default: _withCtx(function () {
      return [!_ctx.bookingInfo ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_button, {
        class: "spinner",
        loading: true
      })])) : _createCommentVNode("", true), _createVNode(_component_el_row, null, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_form, {
            class: "send-email-modal-form",
            ref: "form",
            model: _ctx.ruleForm,
            rules: _ctx.rules,
            "label-position": "top",
            "label-width": "120px",
            "hide-required-asterisk": true
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_form_item, {
                label: _ctx.$t('field.select-option'),
                fill: ""
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_el_radio_group, {
                    modelValue: _ctx.emailType,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
                      return _ctx.emailType = $event;
                    }),
                    style: {
                      "display": "flex",
                      "justify-content": "space-between"
                    }
                  }, {
                    default: _withCtx(function () {
                      return [_createVNode(_component_el_radio, {
                        label: _ctx.EmailTypes.Booking,
                        class: "option-button",
                        size: "large",
                        border: "",
                        style: {
                          "margin-right": "10px"
                        }
                      }, {
                        default: _withCtx(function () {
                          return [_createTextVNode(_toDisplayString(_ctx.$t("button.send-booking")), 1)];
                        }),
                        _: 1
                      }, 8, ["label"]), _createVNode(_component_el_radio, {
                        label: _ctx.EmailTypes.Invoice,
                        class: "option-button",
                        size: "large",
                        border: ""
                      }, {
                        default: _withCtx(function () {
                          return [_createTextVNode(_toDisplayString(_ctx.$t("button.send-invoice")), 1)];
                        }),
                        _: 1
                      }, 8, ["label"])];
                    }),
                    _: 1
                  }, 8, ["modelValue"])];
                }),
                _: 1
              }, 8, ["label"]), _createVNode(_component_el_divider, {
                class: "mb-20"
              }), _createVNode(_component_el_form_item, {
                label: _ctx.$t('field.email'),
                prop: "email",
                fill: ""
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_el_input, {
                    modelValue: _ctx.ruleForm.email,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
                      return _ctx.ruleForm.email = $event;
                    }),
                    modelModifiers: {
                      trim: true
                    },
                    size: "large",
                    placeholder: _ctx.emailType === _ctx.EmailTypes.Invoice && !_ctx.hasCustomerEmail ? _ctx.$t('placeholder.no-customer') : _ctx.$t('field.placeholder-email'),
                    class: "w-100",
                    disabled: _ctx.emailType === _ctx.EmailTypes.Invoice
                  }, {
                    append: _withCtx(function () {
                      return [_createVNode(_component_el_button, {
                        link: "",
                        style: {
                          "font-weight": "700"
                        },
                        onClick: _cache[1] || (_cache[1] = function ($event) {
                          return _ctx.assignOrEditCustomer(_ctx.ModalStatus.SendEmail, {
                            emailType: _ctx.emailType
                          });
                        })
                      }, {
                        default: _withCtx(function () {
                          return [_createTextVNode(_toDisplayString(_ctx.hasCustomerEmail ? _ctx.$t("customers.edit") : _ctx.$t("asideordersummary.assign-customer")), 1)];
                        }),
                        _: 1
                      })];
                    }),
                    _: 1
                  }, 8, ["modelValue", "placeholder", "disabled"])];
                }),
                _: 1
              }, 8, ["label"]), _createElementVNode("div", _hoisted_2, [_createVNode(_component_el_button, {
                class: "py-5 px-6 w-100",
                type: "primary",
                onClick: _cache[3] || (_cache[3] = function ($event) {
                  return _ctx.sendEmail();
                }),
                loading: _ctx.isLoading,
                disabled: _ctx.emailType === _ctx.EmailTypes.Booking && !_ctx.ruleForm.email || _ctx.emailType === _ctx.EmailTypes.Invoice && !_ctx.hasCustomerEmail
              }, {
                default: _withCtx(function () {
                  return [_createTextVNode(_toDisplayString(_ctx.$t("button.send")), 1)];
                }),
                _: 1
              }, 8, ["loading", "disabled"])])];
            }),
            _: 1
          }, 8, ["model", "rules"])];
        }),
        _: 1
      })];
    }),
    _: 1
  }, 8, ["modelValue"]);
}